import { initializeApp, getApps, getApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAYnFhQtgl8aUHGYJB_2EakJ4VNKAaSgYE",
  authDomain: "smora-2c1ba.firebaseapp.com",
  projectId: "smora-2c1ba",
  storageBucket: "smora-2c1ba.firebasestorage.app",
  messagingSenderId: "628844647962",
  appId: "1:628844647962:web:2c8780b9fd95e1a551e3a3",
  measurementId: "G-0FRMJ05GXE",
};

// Initialize Firebase
const app = getApps().length > 0 ? getApp() : initializeApp(firebaseConfig);

// Initialize Analytics safely (only on client side and if supported)
let analytics: any = null;
let messaging: any = null;

if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
  messaging = getMessaging(app);
}

export { app, analytics, messaging };
